export default __webpack_public_path__ + "static/092-7fb2f17792947168465add9339930bf1.jpg";